import script from "./DetailedInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailedInfo.vue?vue&type=script&setup=true&lang=js"

import "./DetailedInfo.vue?vue&type=style&index=0&id=449e467a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-449e467a"]])

export default __exports__